module.exports = __webpack_public_path__ + "static/media/support_black.664c8372.svg";